module.exports = __webpack_public_path__ + "static/media/marker--many.03e68df2.svg";